import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Bind } from 'lodash-decorators';
import styled from 'styled-components';
import ds from 'designsystem';

import {
  HorizontallyNavigableContent as HorizontallyNavigableContentModel,
} from 'models';

import Container from 'blocks/Container/Container';
import ProductSectionParser from 'pages/Product/ProductsSectionParser';
import { Column, Row } from 'hedron';
import {
  hideToRightAnimation,
  showToRightAnimation,
  hideToLeftAnimation,
  showToLeftAnimation,
} from 'animations/Animations';
import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';
import { safeHtmlWithBr } from 'common/methods/string';
import { navigationItemID, isNavItem } from 'common/consts/navigationItem';
import NavButton from './NavButton';
import NavContainer from './NavContainer';
import NavContent from './NavContent';

const StyledContainer = styled(Container)`
  padding-bottom: ${ds.get('metrics.xxl')};
`;

@observer
class HorizontallyNavigableContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentComponentIndex: 0,
      previousComponentIndex: 0,
    };
    this.previousContentRef = React.createRef();
    this.currentContentRef = React.createRef();
  }

  getComponentIndexById(id) {
    const {
      data: {
        contentItems,
      },
    } = this.props;
    return contentItems.indexOf(contentItems.find(item => item.id === id));
  }

  @Bind
  navButtonClick(buttonId) {
    const buttonIndex = this.getComponentIndexById(buttonId);
    const { currentComponentIndex } = this.state;

    if (buttonIndex === currentComponentIndex) {
      return;
    }

    this.setState({
      previousComponentIndex: currentComponentIndex,
      currentComponentIndex: buttonIndex,
    });

    if (currentComponentIndex < buttonIndex) {
      hideToLeftAnimation(this.previousContentRef.current);
      showToLeftAnimation(this.currentContentRef.current);
    } else {
      hideToRightAnimation(this.previousContentRef.current);
      showToRightAnimation(this.currentContentRef.current);
    }
  }

  render() {
    const {
      data: {
        contentItems,
        navigationItem,
        htmlModifiers,
      },
    } = this.props;

    const {
      currentComponentIndex,
      previousComponentIndex,
    } = this.state;

    return (
      <HTMLModifiableBackground
        htmlModifiers={htmlModifiers}
        color={ds.brand('white')}
        id={(navigationItem && isNavItem === navigationItem.toLowerCase() ? navigationItemID : null)}
      >
        <StyledContainer>
          <Row>
            <Column
              lg={11}
            >
              <NavContainer>
                {contentItems && contentItems.map(navItem => (
                  <NavButton
                    active={this.getComponentIndexById(navItem.id) === currentComponentIndex}
                    onClick={() => this.navButtonClick(navItem.id)}
                    key={navItem.id}
                    dangerouslySetInnerHTML={{
                      __html: safeHtmlWithBr(navItem.header),
                    }}
                  />
                ))}
              </NavContainer>
            </Column>
          </Row>
          <NavContent>
            <NavContent
              absolute
              innerRef={this.previousContentRef}
            >
              { previousComponentIndex !== currentComponentIndex
                ? contentItems[previousComponentIndex].contentItems.map(contentItem => (
                  ProductSectionParser(contentItem)
                )) : ''}
            </NavContent>

            <NavContent
              innerRef={this.currentContentRef}
            >
              {contentItems && contentItems[currentComponentIndex].contentItems.map(contentItem => (
                ProductSectionParser(contentItem)
              ))}
            </NavContent>
          </NavContent>
        </StyledContainer>
      </HTMLModifiableBackground>
    );
  }
}
HorizontallyNavigableContent.propTypes = {
  data: PropTypes.instanceOf(HorizontallyNavigableContentModel).isRequired,
};

export default HorizontallyNavigableContent;



// WEBPACK FOOTER //
// ./src/kentico-blocks/HorizontallyNavigableContent/index.jsx